import { AlertCircle, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PaymentFailedPage() {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center px-4 bg-gradient-to-br from-red-50 via-white to-red-50 dark:from-surface-dark dark:via-surface-dark dark:to-surface-dark-50">
      <div className="w-full max-w-[520px] bg-white dark:bg-surface-dark-50 rounded-2xl border border-red-200/60 dark:border-red-500/20 shadow-[0_8px_32px_rgba(239,68,68,0.08)] dark:shadow-dark-lg p-10 text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-red-50 dark:bg-red-500/10 flex items-center justify-center">
            <AlertCircle size={48} className="text-red-500 dark:text-red-400" />
          </div>
        </div>
        <h2 className="text-heading-3 font-bold text-red-600 dark:text-red-400 mb-2">Payment Failed</h2>
        <p className="text-body text-slate-500 dark:text-slate-400 mb-4 px-2">
          We encountered an issue while processing your payment. Your selected medical service was not confirmed.
        </p>
        <p className="text-body font-medium text-slate-700 dark:text-slate-300 mb-6 px-2">
          Please try again or contact <strong>Symbian Health Support</strong> if the issue persists.
        </p>
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-red-600 dark:bg-red-500 text-white font-semibold rounded-xl shadow-[0_2px_8px_rgba(239,68,68,0.3)] hover:shadow-[0_4px_16px_rgba(239,68,68,0.4)] hover:-translate-y-px transition-all"
        >
          <RotateCcw size={18} /> Try Payment Again
        </button>
        <p className="text-ui-sm text-slate-400 dark:text-slate-300 mt-8">Symbian Health © {new Date().getFullYear()} All rights reserved.</p>
      </div>
    </div>
  );
}
